import React from 'react';
import { Button } from '@printdeal/ui-library';

export const SkipLink = ({ target, children }: { target: string, children: React.ReactElement }) => (
  <div className="pd-sr-only pd-left-1 pd-top-1 pd-z-40 focus-within:pd-not-sr-only focus-within:pd-absolute">
    {/* Not a GatsbyLink because that doesn't work... */}
    <Button variant="secondary" as="a" href={`#${target}`}>
      {children}
    </Button>
  </div>
);

export const SkipTarget = ({ id }: { id: string }) => <div id={id} />;
